<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Cancelamento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-area
                no-margin-top
                title="Agendamentos"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-table
                            :fields="fields"
                            :items="agendamentos"
                            @filter-changed="handleAgendamentoFilterChanged"
                            @filtered="agendamentosFiltered = $event"
                        >
                            <template v-slot:head(checkbox)>
                                <rkm-form-checkbox
                                    :indeterminate="indeterminate"
                                    :value="true"
                                    @change="checkUncheckAll"
                                    v-model="checkedAll"
                                />
                            </template>

                            <template v-slot:cell(checkbox)="{item}">
                                <rkm-form-checkbox
                                    :value="true"
                                    @change="handleCheckboxChange"
                                    v-model="item.selecionado"
                                />
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.motivo"
                        label="Motivo"
                        rows="4"
                        v-model="data.model.cancelamento.motivo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="quantidadeAgendamentosSelecionadas === 0"
                @click="cancel"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        quantidadeAgendamentos() {
            return this.agendamentosFiltered.length
        },
        quantidadeAgendamentosSelecionadas() {
            return this.agendamentos
                .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                .filter(agendamento => agendamento.selecionado === true).length
        },
        validations() {
            return {
                motivo: {
                    required: true,
                    max: 500,
                },
            }
        },
    },
    created() {
        this.repositories = {
            gerenciamentoMedico: this.getConectaSusRepository('ambulatorio.gerenciamentoMedico'),
        }
    },
    data: () => ({
        agendamentos: [],
        agendamentosFiltered: [],
        checkedAll: false,
        fields: [
            {key: 'checkbox', label: '#', class: 'col-min text-center'},
            {key: 'horario', label: 'Horário'},
            {key: 'pacienteNome', label: 'Nome'},
            {key: 'pacienteDataNascimento', label: 'Data de nascimento'},
            {key: 'pacienteProntuario', label: 'Prontuário'},
            {key: 'tipoNome', label: 'Tipo'},
            {key: 'pacienteTelefone', label: 'Telefone'},
            {key: 'usuarioAgendadorNome', label: 'Agendador'},
        ],
        indeterminate: false,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.reset()

            this.$refs.RkmModal.show()

            this.load(date)
        },
        load(date) {
            this.setLoading()

            const request = {
                origem: 'origem',
                listar: 'agendamentos',
                usuarioId: this.usuarioId,
                infraestruturaId: this.data.model.origem.infraestruturaId,
                especialidadeId: this.data.model.origem.especialidadeId,
                data: this.others.moment(date).format('DD/MM/YYYY'),
            }

            this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.agendamentos = Object.assign(response.data.agendamentos.map(agendamento => ({...agendamento, selecionado: false})))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAgendamentoFilterChanged() {
            this.checkedAll = false
            this.indeterminate = false
            this.agendamentos.map(agendamento => agendamento.selecionado = false)
        },
        checkUncheckAll(value) {
            this.checkedAll = value
            this.indeterminate = false

            this.agendamentos
                .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                .map(agendamento => agendamento.selecionado = value)
        },
        handleCheckboxChange() {
            this.checkedAll = false
            this.indeterminate = false

            if (this.quantidadeAgendamentosSelecionadas > 0) {
                if (this.quantidadeAgendamentosSelecionadas === this.quantidadeAgendamentos) {
                    this.checkedAll = true
                } else  {
                    this.indeterminate = true
                }
            }
        },
        cancel() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const agendamentos = this.agendamentos
                        .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                        .filter(agendamento => agendamento.selecionado === true)

                    const request = {
                        agendamentos: agendamentos.map(agendamento => (agendamento.id)),
                        motivo: this.data.model.cancelamento.motivo
                    }

                    this.setLoading()

                    this.repositories.gerenciamentoMedico.cancel(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            let warning = ''

                            if (response.data.agendamentosNaoCancelados.statusNaoPermiteAlteracao.length > 0) {
                                let message = ''

                                response.data.agendamentosNaoCancelados.statusNaoPermiteAlteracao.forEach(agendamentoId => {
                                    const agendamento = agendamentos.find(agendamento => agendamento.id === agendamentoId)

                                    message = message + `<li>
                                        Agendamento de ${agendamento.tipoNome} às ${agendamento.horario} horas, agendado por ${agendamento.usuarioAgendadorNome}
                                        para ${agendamento.pacienteNome}, nascido em ${agendamento.pacienteDataNascimento}.
                                    </li>`
                                })

                                warning = warning + `
                                    Agendamento(s) que não permite(m) alteração:
                                    <ul>${message}</ul>
                                `
                            }

                            if (warning) {
                                this.showWarningNotification(warning)
                            } else {
                                this.showSaveNotification()
                            }

                            this.close()
                            this.$emit('saved')
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        close() {
            this.$refs.RkmModal.hide()
        },
        reset() {
            this.agendamentos = []
            this.agendamentosFiltered = []
            this.checkedAll = false
            this.indeterminate = false
            this.data.model.cancelamento.motivo = null
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        usuarioId: {type: Number, required: true},
    },
    watch: {
        agendamentos(value) {
            this.agendamentosFiltered = value
            this.checkedAll = false
            this.indeterminate = false
        },
    },
}
</script>